import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { Container } from '@bootstrap-styled/v4'
import { unitUtils } from '@bootstrap-styled/utils'

// app components
// import Header from './Header'
// import Footer from './Footer'
// import Prefooter from './Prefooter'
import { prefooterData } from './sections/Foot/data/index'

const { math } = unitUtils

// type definition
export type LayoutProps = {
    className?: string
    hasTopbar?: boolean
    hasFooter?: boolean
}

// styled component container
const LayoutStyled = styled.div.attrs<LayoutProps>(props => ({
    className: classNames(props.className, {
        [props.theme['$main-wrap'].replace('.', '')]: true
    })
}))`
    .inner-container {
        padding-top: ${$props => $props.theme['$layout-inner-padding-y']};
        padding-bottom: ${$props => $props.theme['$layout-inner-padding-y']};
        box-sizing: content-box;
        min-height: ${props =>
            `calc(100vh - ${math.addition(
                props.theme['$topbar-height'],
                props.theme['$footer-height']
            )})`};
    }
`

/**
 * Main Layout/container component
 */
const Layout: React.FunctionComponent<LayoutProps> = ({ children, className }) => (
    <LayoutStyled className={className}>
        {/* <Header Logo Navigation className="header" /> */}
        <Container className="inner-container">
            {children}
            {/* <Prefooter data={prefooterData} /> */}
        </Container>
        {/* <Footer /> */}
    </LayoutStyled>
)

export default Layout
